"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const MoveToTop = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/_react.default.createElement("g", {
  className: "fill",
  fill: "#ACB3BE"
}, /*#__PURE__*/_react.default.createElement("circle", {
  cx: 4,
  cy: 7,
  r: 0.75
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M4 6.25h9v1.5H4z"
}), /*#__PURE__*/_react.default.createElement("circle", {
  cx: 13,
  cy: 7,
  r: 0.75
}), /*#__PURE__*/_react.default.createElement("circle", {
  cx: 6,
  cy: 12,
  r: 0.75
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M6 11.25h7v1.5H6z"
}), /*#__PURE__*/_react.default.createElement("circle", {
  cx: 13,
  cy: 12,
  r: 0.75
}), /*#__PURE__*/_react.default.createElement("circle", {
  cx: 8,
  cy: 17,
  r: 0.75
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M8 16.25h5v1.5H8z"
}), /*#__PURE__*/_react.default.createElement("circle", {
  cx: 13,
  cy: 17,
  r: 0.75
}), /*#__PURE__*/_react.default.createElement("circle", {
  cx: 17,
  cy: 4,
  r: 0.75
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M16.25 4h1.5v16h-1.5z"
}), /*#__PURE__*/_react.default.createElement("circle", {
  cx: 17,
  cy: 20,
  r: 0.75
}), /*#__PURE__*/_react.default.createElement("g", {
  transform: "rotate(45 3.672 22.52)"
}, /*#__PURE__*/_react.default.createElement("circle", {
  r: 0.75
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M0-.75h4v1.5H0z"
}), /*#__PURE__*/_react.default.createElement("circle", {
  cx: 4,
  r: 0.75
}))));

var _default = MoveToTop;
exports.default = _default;